// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* frontend/src/components/SanqiStatusBoard.css */

.sanqi-status-board {
  --line: #3a3a3a;
  --panel-bg: #0f1012;
  --panel-inset: #0b0c0e;
  --fg: #dcdcdc;
  --fg-dim: #9aa0a6;
  --accent: #f0a020; /* 介于橙/金之间，贴近截图 */
  --muted: #b8b8b8;
  --ok: #16a34a;
  --warn: #f59e0b;
  --danger: #ef4444;

  width: 100%;
  background: linear-gradient(180deg, var(--panel-bg), var(--panel-inset));
  border: 2px solid var(--line);
  border-radius: 8px;
  padding: 8px;
  color: var(--fg);
  box-shadow: inset 0 0 0 1px #0006, 0 6px 18px rgba(0,0,0,0.45);
  position: relative;
  z-index: 50; /* 兜底，确保高于视频 */
  box-sizing: border-box;
}

.sanqi-status-grid {
  display: grid;
  grid-template-columns: 27% 48% 25%;
  gap: 10px;
}

.panel {
  border: 2px solid var(--line);
  border-radius: 6px;
  background: rgba(0,0,0,0.18);
  overflow: hidden;
}

/* 左侧表格面板 */
.left-panel {
  display: grid;
  grid-template-rows: auto 1fr auto;
}
.left-header,
.left-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
  border-bottom: 1px solid var(--line);
}
.left-two-cols { grid-template-columns: 1fr 1fr !important; }
.left-header {
  background: rgba(255,255,255,0.03);
  font-weight: 600;
  color: var(--fg);
}
.left-cell {
  padding: 10px 12px;
  font-size: 14px;
}
.left-muted { color: var(--fg-dim); }
.left-strong { color: #fff; font-weight: 700; }

/* 中间面板 */
.center-panel { display: grid; grid-template-rows: auto 1fr auto; }
.device-no {
  font-weight: 900;
  font-size: 56px;
  color: var(--accent);
  letter-spacing: 1px;
  padding: 10px 14px;
  border-bottom: 2px solid var(--line);
}
.bar-board {
  display: grid;
  grid-template-rows: auto 1fr auto;
  padding: 10px 14px;
  gap: 8px;
}
.bar-top-labels,
.bar-bottom-labels {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 6px;
  font-size: 12px;
  color: var(--fg);
}
.bar-grid {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  align-items: end;
  gap: 6px;
  height: 130px;
}
.bar-col { display: grid; gap: 6px; }
.bar-cell {
  width: 100%;
  height: 10px;
  background: #1c232b;
  border: 1px solid #242b33;
  border-radius: 2px;
}
.bar-cell.filled { background: linear-gradient(135deg, #00ff88 0%, #00cc66 100%); border-color: #0a5; box-shadow: 0 0 6px rgba(0,255,136,0.35); }
.bar-cell.red { background: linear-gradient(135deg, #ff4444 0%, #cc3333 100%); border-color: #b22222; box-shadow: 0 0 8px rgba(255,68,68,0.6); animation: redGridBlink 1.4s ease-in-out infinite; }

.bar-top-stats, .bar-bottom-stats {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 6px;
  font-size: 12px;
  color: #d0ffd0;
}
.bar-top-stats .turns-number { text-align: center; color: #00ff88; font-weight: 700; text-shadow: 0 0 4px rgba(0,255,136,0.5); }
.bar-bottom-stats .wins-number { text-align: center; color: #ff4d6d; font-weight: 700; text-shadow: 0 0 6px rgba(255,77,109,0.6); }

@keyframes redGridBlink {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 0 8px rgba(255, 68, 68, 0.6);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 0 15px rgba(255, 68, 68, 1);
  }
}
.bar-baseline {
  height: 6px;
  border-radius: 2px;
  background: #cf3d26;
}
.score-area {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  border-top: 2px solid var(--line);
  padding: 10px 14px;
}
.kv { display: flex; gap: 8px; font-size: 18px; }
.kv .label { color: var(--fg); }
.kv .value { color: #fff; font-weight: 700; }

/* 右侧信息面板 */
.right-panel { display: grid; grid-template-rows: auto auto 1fr auto; }
.user-name {
  color: var(--accent);
  font-weight: 800;
  font-size: 28px;
  padding: 10px 14px;
  border-bottom: 2px solid var(--line);
}
.points-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border-bottom: 2px solid var(--line);
}
.p-badge {
  color: var(--accent);
  font-size: 30px;
  font-weight: 900;
}
.p-amount {
  font-size: 32px;
  font-weight: 800;
  color: #ffd08a;
}
.coins-row {
  display: flex; align-items: center; gap: 10px; padding: 12px 14px; border-bottom: 2px solid var(--line);
}
.coin-dot {
  width: 26px; height: 26px; border-radius: 50%;
  background: radial-gradient(circle at 35% 35%, #eee, #bbb 65%, #999 100%);
  border: 2px solid #777;
}
.coin-amount { font-size: 22px; color: #ddd; font-weight: 700; }

.clock {
  display: flex; align-items: center; justify-content: center;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 48px;
  font-weight: 900;
  color: #ffffff;
  padding: 14px;
}

/* 响应式微调 */
@media (max-width: 900px) {
  .sanqi-status-grid { grid-template-columns: 1fr; }
  .clock { font-size: 32px; }
  .device-no { font-size: 36px; }
  .p-amount { font-size: 24px; }
}

/* 移动端：保留与桌面一致的三分区，仅适度缩小字号与间距，绝不隐藏功能 */
@media (max-width: 768px) {
  .sanqi-status-board {
    background: linear-gradient(180deg, var(--panel-bg), var(--panel-inset));
    border-width: 2px;
    padding: 6px;
    width: 100%;
  }
  .sanqi-status-grid { grid-template-columns: 27% 48% 25%; gap: 8px; }
  .left-panel, .center-panel { display: grid; }
  .right-panel { display: grid; grid-template-rows: auto auto 1fr auto; }
  .user-name { font-size: 22px; }
  .p-badge { font-size: 26px; }
  .p-amount { font-size: 28px; }
  .coin-amount { font-size: 18px; }
  .clock { font-size: 36px; }
}

@media (max-width: 480px) {
  .sanqi-status-grid { grid-template-columns: 27% 48% 25%; gap: 6px; }
  .user-name { font-size: 18px; min-width: 0; }
  .p-badge { font-size: 22px; }
  .p-amount { font-size: 22px; }
  .coin-amount { font-size: 16px; }
  .clock { font-size: 28px; }
}
`, "",{"version":3,"sources":["webpack://./src/components/SanqiStatusBoard.css"],"names":[],"mappings":"AAAA,iDAAiD;;AAEjD;EACE,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,iBAAiB;EACjB,iBAAiB,EAAE,iBAAiB;EACpC,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,iBAAiB;;EAEjB,WAAW;EACX,wEAAwE;EACxE,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,8DAA8D;EAC9D,kBAAkB;EAClB,WAAW,EAAE,cAAc;EAC3B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,iCAAiC;AACnC;AACA;;EAEE,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,oCAAoC;AACtC;AACA,iBAAiB,yCAAyC,EAAE;AAC5D;EACE,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA,cAAc,oBAAoB,EAAE;AACpC,eAAe,WAAW,EAAE,gBAAgB,EAAE;;AAE9C,SAAS;AACT,gBAAgB,aAAa,EAAE,iCAAiC,EAAE;AAClE;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,iCAAiC;EACjC,kBAAkB;EAClB,QAAQ;AACV;AACA;;EAEE,aAAa;EACb,sCAAsC;EACtC,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sCAAsC;EACtC,gBAAgB;EAChB,QAAQ;EACR,aAAa;AACf;AACA,WAAW,aAAa,EAAE,QAAQ,EAAE;AACpC;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;AACA,mBAAmB,6DAA6D,EAAE,kBAAkB,EAAE,wCAAwC,EAAE;AAChJ,gBAAgB,6DAA6D,EAAE,qBAAqB,EAAE,uCAAuC,EAAE,iDAAiD,EAAE;;AAElM;EACE,aAAa;EACb,sCAAsC;EACtC,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;AACA,+BAA+B,kBAAkB,EAAE,cAAc,EAAE,gBAAgB,EAAE,wCAAwC,EAAE;AAC/H,iCAAiC,kBAAkB,EAAE,cAAc,EAAE,gBAAgB,EAAE,yCAAyC,EAAE;;AAElI;EACE;IACE,mBAAmB;IACnB,0CAA0C;EAC5C;EACA;IACE,sBAAsB;IACtB,yCAAyC;EAC3C;AACF;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,iCAAiC;EACjC,kBAAkB;AACpB;AACA,MAAM,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE;AAChD,aAAa,gBAAgB,EAAE;AAC/B,aAAa,WAAW,EAAE,gBAAgB,EAAE;;AAE5C,WAAW;AACX,eAAe,aAAa,EAAE,sCAAsC,EAAE;AACtE;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,oCAAoC;AACtC;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,kBAAkB,EAAE,oCAAoC;AACzG;AACA;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB;EAC7C,yEAAyE;EACzE,sBAAsB;AACxB;AACA,eAAe,eAAe,EAAE,WAAW,EAAE,gBAAgB,EAAE;;AAE/D;EACE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,+GAA+G;EAC/G,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA,UAAU;AACV;EACE,qBAAqB,0BAA0B,EAAE;EACjD,SAAS,eAAe,EAAE;EAC1B,aAAa,eAAe,EAAE;EAC9B,YAAY,eAAe,EAAE;AAC/B;;AAEA,sCAAsC;AACtC;EACE;IACE,wEAAwE;IACxE,iBAAiB;IACjB,YAAY;IACZ,WAAW;EACb;EACA,qBAAqB,kCAAkC,EAAE,QAAQ,EAAE;EACnE,6BAA6B,aAAa,EAAE;EAC5C,eAAe,aAAa,EAAE,sCAAsC,EAAE;EACtE,aAAa,eAAe,EAAE;EAC9B,WAAW,eAAe,EAAE;EAC5B,YAAY,eAAe,EAAE;EAC7B,eAAe,eAAe,EAAE;EAChC,SAAS,eAAe,EAAE;AAC5B;;AAEA;EACE,qBAAqB,kCAAkC,EAAE,QAAQ,EAAE;EACnE,aAAa,eAAe,EAAE,YAAY,EAAE;EAC5C,WAAW,eAAe,EAAE;EAC5B,YAAY,eAAe,EAAE;EAC7B,eAAe,eAAe,EAAE;EAChC,SAAS,eAAe,EAAE;AAC5B","sourcesContent":["/* frontend/src/components/SanqiStatusBoard.css */\n\n.sanqi-status-board {\n  --line: #3a3a3a;\n  --panel-bg: #0f1012;\n  --panel-inset: #0b0c0e;\n  --fg: #dcdcdc;\n  --fg-dim: #9aa0a6;\n  --accent: #f0a020; /* 介于橙/金之间，贴近截图 */\n  --muted: #b8b8b8;\n  --ok: #16a34a;\n  --warn: #f59e0b;\n  --danger: #ef4444;\n\n  width: 100%;\n  background: linear-gradient(180deg, var(--panel-bg), var(--panel-inset));\n  border: 2px solid var(--line);\n  border-radius: 8px;\n  padding: 8px;\n  color: var(--fg);\n  box-shadow: inset 0 0 0 1px #0006, 0 6px 18px rgba(0,0,0,0.45);\n  position: relative;\n  z-index: 50; /* 兜底，确保高于视频 */\n  box-sizing: border-box;\n}\n\n.sanqi-status-grid {\n  display: grid;\n  grid-template-columns: 27% 48% 25%;\n  gap: 10px;\n}\n\n.panel {\n  border: 2px solid var(--line);\n  border-radius: 6px;\n  background: rgba(0,0,0,0.18);\n  overflow: hidden;\n}\n\n/* 左侧表格面板 */\n.left-panel {\n  display: grid;\n  grid-template-rows: auto 1fr auto;\n}\n.left-header,\n.left-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  align-items: center;\n  border-bottom: 1px solid var(--line);\n}\n.left-two-cols { grid-template-columns: 1fr 1fr !important; }\n.left-header {\n  background: rgba(255,255,255,0.03);\n  font-weight: 600;\n  color: var(--fg);\n}\n.left-cell {\n  padding: 10px 12px;\n  font-size: 14px;\n}\n.left-muted { color: var(--fg-dim); }\n.left-strong { color: #fff; font-weight: 700; }\n\n/* 中间面板 */\n.center-panel { display: grid; grid-template-rows: auto 1fr auto; }\n.device-no {\n  font-weight: 900;\n  font-size: 56px;\n  color: var(--accent);\n  letter-spacing: 1px;\n  padding: 10px 14px;\n  border-bottom: 2px solid var(--line);\n}\n.bar-board {\n  display: grid;\n  grid-template-rows: auto 1fr auto;\n  padding: 10px 14px;\n  gap: 8px;\n}\n.bar-top-labels,\n.bar-bottom-labels {\n  display: grid;\n  grid-template-columns: repeat(12, 1fr);\n  gap: 6px;\n  font-size: 12px;\n  color: var(--fg);\n}\n.bar-grid {\n  display: grid;\n  grid-template-columns: repeat(12, 1fr);\n  align-items: end;\n  gap: 6px;\n  height: 130px;\n}\n.bar-col { display: grid; gap: 6px; }\n.bar-cell {\n  width: 100%;\n  height: 10px;\n  background: #1c232b;\n  border: 1px solid #242b33;\n  border-radius: 2px;\n}\n.bar-cell.filled { background: linear-gradient(135deg, #00ff88 0%, #00cc66 100%); border-color: #0a5; box-shadow: 0 0 6px rgba(0,255,136,0.35); }\n.bar-cell.red { background: linear-gradient(135deg, #ff4444 0%, #cc3333 100%); border-color: #b22222; box-shadow: 0 0 8px rgba(255,68,68,0.6); animation: redGridBlink 1.4s ease-in-out infinite; }\n\n.bar-top-stats, .bar-bottom-stats {\n  display: grid;\n  grid-template-columns: repeat(12, 1fr);\n  gap: 6px;\n  font-size: 12px;\n  color: #d0ffd0;\n}\n.bar-top-stats .turns-number { text-align: center; color: #00ff88; font-weight: 700; text-shadow: 0 0 4px rgba(0,255,136,0.5); }\n.bar-bottom-stats .wins-number { text-align: center; color: #ff4d6d; font-weight: 700; text-shadow: 0 0 6px rgba(255,77,109,0.6); }\n\n@keyframes redGridBlink {\n  0%, 100% {\n    transform: scale(1);\n    box-shadow: 0 0 8px rgba(255, 68, 68, 0.6);\n  }\n  50% {\n    transform: scale(1.05);\n    box-shadow: 0 0 15px rgba(255, 68, 68, 1);\n  }\n}\n.bar-baseline {\n  height: 6px;\n  border-radius: 2px;\n  background: #cf3d26;\n}\n.score-area {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  border-top: 2px solid var(--line);\n  padding: 10px 14px;\n}\n.kv { display: flex; gap: 8px; font-size: 18px; }\n.kv .label { color: var(--fg); }\n.kv .value { color: #fff; font-weight: 700; }\n\n/* 右侧信息面板 */\n.right-panel { display: grid; grid-template-rows: auto auto 1fr auto; }\n.user-name {\n  color: var(--accent);\n  font-weight: 800;\n  font-size: 28px;\n  padding: 10px 14px;\n  border-bottom: 2px solid var(--line);\n}\n.points-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px;\n  border-bottom: 2px solid var(--line);\n}\n.p-badge {\n  color: var(--accent);\n  font-size: 30px;\n  font-weight: 900;\n}\n.p-amount {\n  font-size: 32px;\n  font-weight: 800;\n  color: #ffd08a;\n}\n.coins-row {\n  display: flex; align-items: center; gap: 10px; padding: 12px 14px; border-bottom: 2px solid var(--line);\n}\n.coin-dot {\n  width: 26px; height: 26px; border-radius: 50%;\n  background: radial-gradient(circle at 35% 35%, #eee, #bbb 65%, #999 100%);\n  border: 2px solid #777;\n}\n.coin-amount { font-size: 22px; color: #ddd; font-weight: 700; }\n\n.clock {\n  display: flex; align-items: center; justify-content: center;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  font-size: 48px;\n  font-weight: 900;\n  color: #ffffff;\n  padding: 14px;\n}\n\n/* 响应式微调 */\n@media (max-width: 900px) {\n  .sanqi-status-grid { grid-template-columns: 1fr; }\n  .clock { font-size: 32px; }\n  .device-no { font-size: 36px; }\n  .p-amount { font-size: 24px; }\n}\n\n/* 移动端：保留与桌面一致的三分区，仅适度缩小字号与间距，绝不隐藏功能 */\n@media (max-width: 768px) {\n  .sanqi-status-board {\n    background: linear-gradient(180deg, var(--panel-bg), var(--panel-inset));\n    border-width: 2px;\n    padding: 6px;\n    width: 100%;\n  }\n  .sanqi-status-grid { grid-template-columns: 27% 48% 25%; gap: 8px; }\n  .left-panel, .center-panel { display: grid; }\n  .right-panel { display: grid; grid-template-rows: auto auto 1fr auto; }\n  .user-name { font-size: 22px; }\n  .p-badge { font-size: 26px; }\n  .p-amount { font-size: 28px; }\n  .coin-amount { font-size: 18px; }\n  .clock { font-size: 36px; }\n}\n\n@media (max-width: 480px) {\n  .sanqi-status-grid { grid-template-columns: 27% 48% 25%; gap: 6px; }\n  .user-name { font-size: 18px; min-width: 0; }\n  .p-badge { font-size: 22px; }\n  .p-amount { font-size: 22px; }\n  .coin-amount { font-size: 16px; }\n  .clock { font-size: 28px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
